import { Textarea } from '@design-system';

interface QuestionBodyParagraphProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function QuestionBodyParagraph({
  value,
  onChange,
  placeholder,
  disabled,
}: QuestionBodyParagraphProps) {
  return (
    <Textarea
      autoFocus
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      rows={12}
    />
  );
}
